var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnimatedText = void 0;
var _react = require("react");
var _reactNative = require("react-native");
var _createAnimatedComponent = _interopRequireDefault(require("../../createAnimatedComponent/createAnimatedComponent"));
var AnimatedText = exports.AnimatedText = (0, _createAnimatedComponent.default)(_reactNative.Text);
